import { Injectable } from '@angular/core';
import { GridLayoutService } from '@irb-common/interfaces/grid-layout.service';
import { DialogAccountMultieditViewComponent } from '@irb/irb-dialogs/dialog-account-multiedit-view/dialog-account-multiedit-view.component';
import { TruncateTooltipCellComponent } from '@irb-common/components/grid/renderers/truncatetooltip.cell.component';
import { IrbAgSearchMultipleColumnFilterComponent } from '@irb/irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-search-multiple-column-filter/irb-ag-search-multiple-column-filter.component';

@Injectable({
    providedIn: 'root'
})
export class DialogAccountMultieditViewGridLayoutService implements GridLayoutService<DialogAccountMultieditViewComponent> {
    constructor() {}

    getFrameworkComponents() {
        return {
            "TruncateTooltipCellComponent": TruncateTooltipCellComponent
        };
    }

    getColumnDefs(_parent: DialogAccountMultieditViewComponent) {
        return [
            {
                headerName: 'Name',
                field: 'accountName',
                suppressFiltersToolPanel: true,
                suppressMovable: true,
                cellRenderer: 'cellRendererFormatter',
                floatingFilterComponent: 'irbInputFloatingFilterComponent',
                filter: 'irbAgSearchMultipleColumnFilterComponent',
                filterParams: {
                    search: (str: string, d: IrbAgSearchMultipleColumnFilterComponent) => _parent.getAssignedAccountName(str, d),
                    threshold: 2,
                    field: "accountId",
                    displayField: "name",
                    enableHiddenSearchResults: true
                },
                minWidth: 180,
                flex: 2
            },{
                headerName: 'Type',
                suppressFiltersToolPanel: true,
                field: 'accountsubType',
                minWidth: 120,
                width: 120,
                cellRenderer: 'cellRendererFormatter',
                filter: 'agSetColumnFilter',
                filterParams: {
                    buttons:['reset', 'apply'],
                    newRowsAction: 'keep',
                    suppressSorting: true,
                    cellHeight: 30,                    
                    refreshValuesOnOpen: true,
                    closeOnApply: true,
                    values: (_params: any) => {
                        _params.success(_parent.accountSubTypeList);
                    },
                }
            },{
                headerName: 'Market Value',
                suppressFiltersToolPanel: true,
                field: 'marketValue',
                cellRenderer: 'cellRendererFormatter',
                cellRendererParams: {type: 'currency'},
                floatingFilterComponent: 'irbInputFloatingFilterComponent',
                filter: 'irbAgNumberColumnFilterComponent',
                minWidth: 90,
                width: 220
            }
        ];
    }
}
